import { render, staticRenderFns } from "./AboutBox.vue?vue&type=template&id=011be94d&scoped=true&"
import script from "./AboutBox.vue?vue&type=script&lang=js&"
export * from "./AboutBox.vue?vue&type=script&lang=js&"
import style0 from "./AboutBox.vue?vue&type=style&index=0&id=011be94d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011be94d",
  null
  
)

export default component.exports